// src/components/HomeFooter.jsx
import React from 'react';
import { Box, Link, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import routes from '../Config/routes';

export default function HomeFooter({ sx = {} }) {
  return (
    <Box
      component="footer"
      sx={{
        ...sx,
        backgroundColor: '#111111',
        color: '#FFF',
        px: { xs: 2, md: 6 },
        py: { xs: 6, md: 10 },
      }}
    >
      <Box
        display="flex"
        flexWrap="wrap"
        justifyContent="space-between"
        maxWidth="1200px"
        mx="auto"
        mb={4}
      >
        {/* Product */}
        <Box mb={3}>
          <Typography variant="subtitle2" gutterBottom>
            Product
          </Typography>
          <Link component={RouterLink} to={routes.solutions} display="block" color="inherit" underline="hover">
            Pay
          </Link>
          <Link component={RouterLink} to={routes.create} display="block" color="inherit" underline="hover">
            Create
          </Link>
          <Link component={RouterLink} to={routes.collaborate} display="block" color="inherit" underline="hover">
            Collaborate
          </Link>
        </Box>

        {/* Company */}
        <Box mb={3}>
          <Typography variant="subtitle2" gutterBottom>
            Company
          </Typography>
          <Link component={RouterLink} to={routes.about} display="block" color="inherit" underline="hover">
            About
          </Link>
          <Link component={RouterLink} to={routes.investors} display="block" color="inherit" underline="hover">
            Investors
          </Link>
         
        </Box>

        {/* Resources */}
        <Box mb={3}>
          <Typography variant="subtitle2" gutterBottom>
            Resources
          </Typography>
          <Link component={RouterLink} to={routes.solutions} display="block" color="inherit" underline="hover">
            Solutions
          </Link>
          <Link component={RouterLink} to={routes.forcreators} display="block" color="inherit" underline="hover">
            For Creators
          </Link>
          <Link component={RouterLink} to={routes.solutionsAgencies} display="block" color="inherit" underline="hover">
            For Agencies
          </Link>
          <Link component={RouterLink} to={routes.articles} display="block" color="inherit" underline="hover">
            Articles
          </Link>
          <Link component={RouterLink} to={routes.releasteNotes} display="block" color="inherit" underline="hover">
            Release Notes
          </Link>
          <Link component={RouterLink} to={routes.help} display="block" color="inherit" underline="hover">
            Help Center
          </Link>
        </Box>

        {/* Legal */}
        <Box mb={3}>
          <Typography variant="subtitle2" gutterBottom>
            Legal
          </Typography>
          <Link component={RouterLink} to={routes.privacyPolicy} display="block" color="inherit" underline="hover">
            Privacy Policy
          </Link>
          <Link component={RouterLink} to={routes.agencyTerms} display="block" color="inherit" underline="hover">
            Terms of Service
          </Link>
        </Box>
      </Box>

      <Typography variant="body2" color="inherit" align="center">
        © 2026 Blitz Systems Corp. All Rights Reserved.
      </Typography>
    </Box>
  );
}
